import { SET_EDIT_PROFILE_DATA } from '../types'
export default (state = false, action) => {
  switch (action.type) {
    case SET_EDIT_PROFILE_DATA:
      return action.payload
    default:
      return state;
  }
}